import { useGalleryToImageProps } from './useGalleryToImageProps';

import type { AiPicture, Hotel } from '~~/domains/graphql';

type HotelKidsAndFamily = {
  images: AiImageProps[];
};

export function useHotelKidsAndFamily(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<HotelKidsAndFamily> {
  return computed<HotelKidsAndFamily>(() => {
    const images = useGalleryToImageProps(
      (hotel.value?.kfGalleryImages as AiPicture[]) ?? null,
    );

    return {
      images,
    };
  });
}
